import { translateColumns } from "../../../../../utils/tableUtils";
import { useTranslation } from "react-i18next";
import { message, Modal, Table, TableColumnsType, TableProps } from "antd";
import { useAuthStore } from "../../../../../stores/stores";
import { ChangeEvent, useEffect, useState } from "react";
import FormItemInput from "../../../../../components/form-input/FormInput";
import { SearchOutlined } from "@ant-design/icons";
import { formatDateV2 } from "../../../../../utils/converDate";
import "./ManyApprovals.scss";
import TableData from "../../../../../components/table-data/TableData";
import { DataType } from "../../../../../types/listUsers";
import { getListAssign } from "../../../../../service/assign-course-construction";

import { ApprovalType } from "../../../../../types/survey-browse";

import { get, isEmpty } from "lodash";
import { HelpService } from "../../../../../service/helper.service";
import {
  approvalStatus,
  approvalStatusEum,
  courseStatusEum,
} from "../../constants/data";
import {
  approveManySurvey,
  postCoursePlanSearchAllApprove,
  postCoursePlanSearchApprove,
  postSurveySearchApprove,
} from "../../../../../service/course-plan-managment/mooc-approval-plan/mooc-approval-plan-api";
import { FilterDateCoursePlan } from "../../../../../types/course-plan-approval";
import Item from "antd/es/list/Item";
import {
  CreareCoursePlanArroval,
  CrearteManyCoursePlanArroval,
  FilterDataMoocApproval,
} from "../../../../../types/course-plan-managment/mooc-approval";
import { postMoocApprovalCourseSearch } from "../../../../../service/course-plan-managment/mooc-approval-course-registration/mooc-approval-course-registration-api";

interface RowKeyType {
  id: number;
}
type Props = {
  open: boolean;
  handleCancel: () => void;
  data: any;
  // filterData: FilterDataMoocApproval;
};
export default function ManyApprovalsSurvey(props: Props) {
  const { t } = useTranslation();
  const { open, handleCancel, data } = props;
  const userId = useAuthStore((states) => states.user?.id);
  const [searchValue, setSearchValue] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [listSurveyMany, setListSurveyMany] = useState<ApprovalType[]>([]);
  const helpService = new HelpService();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  // const [filterData, setFilterData] = useState<FilterDataMoocApproval>({
  //   submissionDate: null,
  //   approvalDate: null,
  // });
  const handleReturnStatus = (record: any) => {
    switch (record.constructionPlanStatus) {
      // case approvalStatusEum.SAVE_DRAFT:
      //   return t("Lưu bản nháp", "Lưu bản nháp");
      case approvalStatusEum.WAIT_APPROVE:
        return t("Chờ duyệt", "Chờ duyệt");
      case approvalStatusEum.APPROVED:
        return t("Đã duyệt", "Đã duyệt");
      case approvalStatusEum.REFUSE:
        return t("Từ chối", "Từ chối");
      // case approvalStatusEum.PUBLISHED:
      //   return t("Đã xuất bản", "Đã xuất bản");
      // case approvalStatusEum.END:
      //   return t("Kết thúc", "Kết thúc");
      default:
        return "";
    }
  };
  const dataColumns: TableColumnsType<any> = [
    {
      title: t("STT", "STT"),
      width: 10,
      render: (_: any, record, index: number) => {
        const orderNumber = (index + 1).toString().padStart(2, "0");
        return <span className="table-order-header">{orderNumber}</span>;
      },
    },
    {
      title: t("Tên khóa học", "Tên khóa học"),
      sorter: (a, b) => a.registrationName.localeCompare(b.registrationName),
      width: 60,
      dataIndex: "registrationName",
    },
    {
      title: t("Ngày gửi", "Ngày gửi"),
      width: 20,
      dataIndex: "submissionDate",
      render: (_: any, record) => {
        return (
          <>
            {record.submissionDate ? formatDateV2(record.submissionDate) : null}
          </>
        );
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      width: 30,
      dataIndex: "constructionPlanStatus",
      render: (_: any, record) => {
        return (
          <div className="table-status">
            <div
              className="color-icon"
              style={{
                backgroundColor: approvalStatus.filter(
                  (x) => x.value == record.constructionPlanStatus
                )[0]?.color,
              }}
            ></div>
            {
              approvalStatus.filter(
                (x) => x.value == record.constructionPlanStatus
              )[0]?.text
            }
          </div>
        );
      },
    },
  ];
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    // setStatusOrder(data);
    // setFieldSortOrder(sorter.field);
  };
  const getListData = (type: boolean) => {
    setLoading(true);
    const data = {
      keyword: searchValue,
      pageNumber: pageNumber,
      pageSize: pageSize,
      // id: !isEmpty(filterData.id) ? filterData.id : null,
      // courseConstructionPlanId: !isEmpty(filterData.courseConstructionPlanId)
      //   ? filterData.courseConstructionPlanId
      //   : null,
      // approvalDateFrom: !isEmpty(filterData.approvalDate?.[0])
      //   ? filterData.approvalDate?.[0].toString()
      //   : null,
      // approvalDateTo: !isEmpty(filterData.approvalDate?.[1])
      //   ? filterData.approvalDate?.[1].toString()
      //   : null,
      // approvalRemark: !isEmpty(filterData.approvalRemark)
      //   ? filterData.approvalRemark
      //   : null,
      // individualId: !isEmpty(filterData.individualId)
      //   ? filterData.individualId
      //   : null,
      // createdDateFrom: !isEmpty(filterData.createdDate?.[0])
      //   ? filterData.createdDate?.[0].toString()
      //   : null,
      // createdDateTo: !isEmpty(filterData.createdDate?.[1])
      //   ? filterData.createdDate?.[1].toString()
      //   : null,
      // sortField: fieldSortOrder,
      // sortOrder: statusOrder,
    };

    postMoocApprovalCourseSearch(data)
      .then((res) => {
        // const { data } = res.data;
        let dataTable = res.data.data.data.map((item: any) => {
          return {
            id: item.courseConstructionPlanId ?? undefined,
            registrationName: item.courseConstructionPlanName ?? undefined,
            submissionDate: item.createdDate ?? undefined,
            approvalDate: item.approvalDate ?? undefined,
            constructionPlanStatus: item.courseConstructionStatus ?? undefined,
            organzationId: item.organzationId ?? undefined,
            submitterId: item.submitterId ?? undefined,
            individualId: item.individualId ?? undefined,
          };
        });
        setListSurveyMany(dataTable);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        message.error(err.message);
      });
  };
  useEffect(() => {
    if (open) {
      getListData(false);
    }
  }, [open]);
  const onOk = () => {
    if (selectedRowKeys.length > 0) {
      const dataSend: CrearteManyCoursePlanArroval[] =
        // organzationId: listSurveyMany[0]?.organzationId ?? undefined,
        (selectedRowKeys as unknown as RowKeyType[]).map((i) => {
          let data = listSurveyMany.filter((x) => x.id == i.id);
          return {
            courseIds: i.id,
            individualId: data[0]?.individualId ?? undefined,
            organzationId: data[0]?.organzationId ?? undefined,
            courseStatus: approvalStatusEum.APPROVED,
            submitterId: data[0]?.submitterId ?? undefined,
          };
        });
      // courseStatus: approvalStatusEum.APPROVED,

      approveManySurvey(dataSend)
        .then((res) => {
          const { data, statusCode, message } = res.data;
          if (statusCode === 200) {
            helpService.successMessage(get(data, "message", message));
            setTimeout(() => handleCancel(), 500);
          }
        })
        .catch((err) => {
          console.log(err);
          message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
        });
    } else {
      handleCancel();
    }
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
    
  };
  const handleSubmitSearch = () => {    
    getListData(false);
  };
  const disableButton = selectedRowKeys.length === 0 ? true : false;

  return (
    <>
      <Modal
        title={t("Phê duyệt nhiều Lập kế hoạch xây dựng khóa học", "Phê duyệt nhiều Lập kế hoạch xây dựng khóa học")}
        centered
        open={open}
        okText={t("Xác nhận phê duyệt", "Xác nhận phê duyệt")}
        cancelText={t("Huỷ", "Huỷ")}
        onOk={onOk}
        onCancel={handleCancel}
        width={1000}
        okButtonProps={{ disabled: disableButton }}
      >
        <FormItemInput
          placeholder={t("Nhập từ khoá cần tìm", "Nhập từ khoá cần tìm")}
          value={searchValue}
          onChange={handleChangeInput}
          afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />}
        />
        <div className="title-custom-many-approval">
          <h1 className="title-custom-many-approval-h1">{t("Danh sách kế hoạch", "Danh sách kế hoạch")} </h1>
          <span className="title-custom-many-approval-span">
            ({t("Đã chọn", "Đã chọn")} {selectedRowKeys.length}/{listSurveyMany.length} {t("kế hoạch", "kế hoạch")})
          </span>
        </div>
        <TableData
          dataTable={listSurveyMany}
          searchValue = { searchValue }
          dataColumns={dataColumns}
          hideSelection={true}
          loadingTable={loading}
          setSelectedRowKeysProps={setSelectedRowKeys}
          handleTableChangeProps={handleTableChange}
        />
      </Modal>
    </>
  );
}
